import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import Message from "../../../../i18n/Message";
import CheckIcon from "../../../../assets/icons/CheckIcon";
import Spinner from "../../../../assets/icons/Spinner";
import ModelSelectionPanel from "../../chats/list/ModelSelectionPanel";
import { updateAssistant } from "../store/assistantActionCreators";

import "./AssistantModelSettings.scss";

const AssistantModelSettings = ({ assistant, workspaceId }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [modelId, setModelId] = useState(assistant.modelId);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    if (assistant) {
      setModelId(assistant.modelId);
      setHasChanges(false);
    }
  }, [assistant?.uid, assistant?.modelId]);

  useEffect(() => {
    const modelChanged = modelId !== assistant.modelId;
    setHasChanges(modelChanged);
  }, [modelId, assistant?.modelId]);

  const onSave = () => {
    setSaveInProgress(true);
    const onFinished = () => {
      setSaveInProgress(false);
      setHasChanges(false);
    };
    dispatch(
      updateAssistant(
        intl,
        workspaceId,
        assistant.uid,
        {
          modelId,
        },
        onFinished,
        onFinished
      )
    );
  };

  return (
    <>
      <div className="card_header">
        <div className="card_title">
          <Message id="assistant_model" />
        </div>
        <div className="card_actions">
          <button
            className="btn btn-outline-dark btn-sm"
            disabled={saveInProgress || !hasChanges}
            onClick={onSave}
          >
            {saveInProgress ? (
              <Spinner size="18" />
            ) : (
              <CheckIcon size="18" color="#67748e" strokeWidth="2" />
            )}
            <Message id="save" />
          </button>
        </div>
      </div>

      <div className="settings_sections">
        <div className="settings_section">
          <div className="model_selection_wrapper">
            <ModelSelectionPanel modelId={modelId} setModelId={setModelId} showAssistants={false} />
          </div>
        </div>

        <div className="bottom_actions">
          <button
            className="btn bg-gradient-dark"
            disabled={saveInProgress || !hasChanges}
            onClick={onSave}
          >
            {saveInProgress ? (
              <Spinner size="18" />
            ) : (
              <CheckIcon size="18" color="#fff" strokeWidth="2" />
            )}
            <Message id="save" />
          </button>
        </div>
      </div>
    </>
  );
};

export default AssistantModelSettings;
